<template>
  <div class="px-4 sm:px-0">
    <PageTitle
      :title="$gettext('Classification des pays par risque')"
      :description="$gettext('Selon différentes sources officielles.')"
    />
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div class="relative w-full mb-4">
            <MagnifyingGlassIcon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 size-5" />
            <input v-model="countryStore.searchQuery" type="text" :placeholder="$gettext('Chercher un pays...')"
              class="w-full pl-10 p-2 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
          </div>
          <ul role="list" class="divide-y divide-gray-300">
            <li v-for="country in countryStore.paginatedCountries" :key="country.attributes.isoCode" class="cursor-pointer"
              @click="toggleCountry(country.attributes.code)">

              <div class="flex justify-between gap-x-6 py-5">
                <div class="flex min-w-0 gap-x-4">
                  <span
                    :class="['!size-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 fi fis fi-' + country.attributes.code.toLowerCase()]"
                    alt=""></span>
                  <div class="min-w-0 flex-auto">
                    <p class="text-sm font-semibold">{{ country.attributes.name }}</p>
                    <p class="mt-1 truncate text-xs text-gray-400">{{ country.attributes.code }}</p>
                  </div>
                </div>
                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                  <RiskScoringLabel :level="country.attributes.amlRiskRating" />
                </div>
              </div>

              <div v-if="expandedCountry === country.attributes.code && (country.attributes.fatfBlacklist || country.attributes.fatfGreylist || country.attributes.euHrtc || country.attributes.euTaxNonCooperative || country.attributes.beTaxNonCooperative || country.attributes.euSanction) "
                class="overflow-hidden transition-all duration-300 ease-in-out rounded-lg p-4 grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
                <div class="text-sm flex justify-between" v-if="country.attributes.fatfBlacklist">
                  <span class="text-red-400 font-normal">{{ $gettext("Liste noire du GAFI") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
                <div class="text-sm flex justify-between" v-if="country.attributes.fatfGreylist">
                  <span class="text-red-400 font-normal">{{ $gettext("Liste grise du GAFI") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
                <div class="text-sm flex justify-between" v-if="country.attributes.euHrtc">
                  <span class="text-red-400 font-normal">{{ $gettext("Liste UE pays tiers à haut risque") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
                <div class="text-sm flex justify-between" v-if="country.attributes.euTaxNonCooperative">
                  <span class="text-red-400 font-normal">{{ $gettext("Liste UE pays non coopératifs à des fins fiscales") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
                <div class="text-sm flex justify-between" v-if="country.attributes.beTaxNonCooperative">
                  <span class="text-red-400 font-normal">{{ $gettext("Liste belge paradis fiscaux") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
                <div class="text-sm flex justify-between" v-if="country.attributes.euSanction">
                  <span class="text-red-400 font-normal">{{ $gettext("Sujet à des sanctions Européennes") }}</span>
                  <ExclamationTriangleIcon class="h-4 text-red-400"></ExclamationTriangleIcon>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <PaginationNavigation :store="countryStore" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useCountryStore } from "@/stores/country.js";
import { ExclamationTriangleIcon, MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import PaginationNavigation from "@/components/layout/PaginationNavigation.vue";
import RiskScoringLabel from "@/components/risk-scorings/RiskScoringLabel.vue";
import PageTitle from "@/components/layout/PageTitle.vue";

const countryStore = useCountryStore();

const expandedCountry = ref(null);
const toggleCountry = (isoCode) => {
  expandedCountry.value = expandedCountry.value === isoCode ? null : isoCode;
};

</script>
